// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__18BbB","messages":"Chat_messages__39x1W","dateDivider":"Chat_dateDivider__3cbDA"};